import { render } from "./data-migration.vue?vue&type=template&id=18ab97e4"
import script from "./data-migration.vue?vue&type=script&lang=ts"
export * from "./data-migration.vue?vue&type=script&lang=ts"
script.render = render

export default script